export default __webpack_public_path__ + "static/media/noimg.018bd907.jpg";